<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101306"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.eqType.code')">
            <el-input v-model="editDialog.form.code" no="code" :disabled="tenantId!==PLATFORM_TENANT_ID" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.eqType.name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.eqType.localName')">
            <el-input v-model="editDialog.form.localName" no="localName" />
          </el-form-item>
          <el-form-item>
            <span slot="label" style="display: flex;">
              {{ $t('CargoMsg.Cargo_SpecialSize') }}
              <el-tooltip :content="$t('CargoMsg.Cargo_SpecialSizeTip')" placement="right">
                <i class="el-icon-question" style="cursor: pointer;color: #1F75D5;" />
              </el-tooltip>
            </span>
            <el-checkbox v-model="editDialog.form.specialSize" no="specialSize" @change="specialSizeChangeHandler" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Reefer')">
            <el-checkbox v-model="editDialog.form.reefer" no="reefer" @change="reeferChangeHandler" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.eqType.remark')">
            <el-input v-model="editDialog.form.remark" no="remark" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('CargoMsg.Cargo_SelectAddPlatformContainerType')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-e-q-type />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseEQType from './baseEQType'
import { getUserInfo } from '@/utils/auth'
import { getEQTypeList, getEQTypesByPlatform, saveEQType, addEQTypeByPlatform, saveEQTypes, delEQType } from '@/api/basicData/eqType'
import { getLoading } from '@/utils/utilBaseElement'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'EQType',
  components: { baseEQType },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.eqType.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.eqType.name'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.eqType.localName'),
          field: 'localName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.eqType.remark'),
          field: 'remark',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SpecialSize'),
          field: 'specialSize',
          width: 100,
          cellRenderer: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Reefer'),
          field: 'reefer',
          width: 100,
          cellRenderer: params => ColumnUtils.booleanColumnLabelFunc(params.value)
        }
      ],
      rowData: null,
      tenantId: '',
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          name: '',
          localName: '',
          remark: '',
          specialSize: false,
          reefer: false
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getEQTypeList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getEQTypesByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          code: '',
          name: '',
          localName: '',
          remark: '',
          specialSize: false,
          reefer: false
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_SelectAddPlatformContainerType')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_ContainerTypeMaintenance')
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.eqType.codeCheck'))
        return
      }
      let saveFunc = saveEQType
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addEQTypeByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        syncSpecificBasicData(basicCacheKeys.basic_data_EQType)
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delEQType(rows[0].uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          syncSpecificBasicData(basicCacheKeys.basic_data_EQType)
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseEQType) {
        document.resetBaseEQType()
      } else {
        setTimeout(() => {
          document.resetBaseEQType()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseEQTypeRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          code: item.code,
          name: item.name,
          localName: item.localName,
          remark: item.remark,
          specialSize: item.specialSize,
          reefer: item.reefer
        })
      }
      saveEQTypes(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    },
    specialSizeChangeHandler(value) {
      this.editDialog.form.specialSize = value
      if (value) {
        this.editDialog.form.reefer = false
      }
    },
    reeferChangeHandler(value) {
      this.editDialog.form.reefer = value
      if (value) {
        this.editDialog.form.specialSize = false
      }
    }
  }
}
</script>

<style>
</style>
